// popupnew.js
window.addEventListener('load', function () {

  // Esperar 0.7s después de que TODO cargó
  setTimeout(() => {

    const popups = document.querySelectorAll('.popupnew');
    if (!popups.length) return;

    if (!document.getElementById('popupnew-style')) {
      const style = document.createElement('style');
      style.id = 'popupnew-style';
      style.innerHTML = `
        image-with-text-overlay.image-with-text-overlay.text-center {
          margin-bottom: 0;
        }
        @media (max-width: 600px) {
          body .popup-content {
            background: transparent;
            height: auto;
          }
        }
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9998;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }
        .popup-overlay.active {
          opacity: 1;
          pointer-events: auto;
        }
        .popup-content {
          position: relative;
          background: transparent;
          padding: 0;
          width: 70%;
          height: 85%;
          overflow: hidden;
          z-index: 9999;
          animation: popIn 0.3s ease forwards;
        }
        @keyframes popIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        .popup-close {
          position: absolute;
          right: 0;
          background: white;
          border: none;
          font-size: 22px;
          font-weight: bold;
          cursor: pointer;
          width: 30px;
          height: 30px;
          z-index: 9;
        }
      `;
      document.head.appendChild(style);
    }

    popups.forEach((popupElement) => {
      const overlay = document.createElement('div');
      overlay.className = 'popup-overlay';

      const content = document.createElement('div');
      content.className = 'popup-content';

      const closeBtn = document.createElement('button');
      closeBtn.className = 'popup-close';
      closeBtn.innerHTML = '&times;';

      content.appendChild(closeBtn);
      content.appendChild(popupElement);
      overlay.appendChild(content);
      document.body.appendChild(overlay);

      setTimeout(() => overlay.classList.add('active'), 2000);

      closeBtn.addEventListener('click', () => overlay.classList.remove('active'));
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) overlay.classList.remove('active');
      });
    });

  }, 700);
});
